import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarSystemPricingDto } from "../dto/solar-proposal-system-pricing.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The System Pricing step as the server built it for this viewer: grouped
 * rows, totals, margin bounds and editability. A pure read; it never prices.
 */
export default function useSolarProposalSystemPricing(
  proposalId: string | undefined,
): UseQueryResult<SolarSystemPricingDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.systemPricing(proposalId ?? ``),
    queryFn: () => solarProposalService.getSystemPricing(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
